"use client";

import type { JSX, ReactNode } from "react";

import { LinkButton } from "@repo/ui/link-button";

import { pushEvent } from "@/lib/analytics";

interface DirectionsLinkProps {
  href: string;
  itemName?: string;
  locationZone?: string;
  className?: string;
  children: ReactNode;
}

export function DirectionsLink({
  href,
  itemName,
  locationZone,
  className,
  children,
}: DirectionsLinkProps): JSX.Element {
  return (
    <LinkButton
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      underline
      size="md"
      className={className}
      onClick={() =>
        pushEvent({
          event: "get_directions",
          item_name: itemName,
          location_zone: locationZone,
        })
      }
    >
      {children}
    </LinkButton>
  );
}
